import { Observable } from 'rxjs';
import { IGetGateway } from '../../gateways';
import { COUNTRIES_SCHEMA, ICountry } from '@web/dtos';
import { API_RESPONSE_SCHEMA, IApiResponse } from '@web/shared-types';
import { RestCallBuilder } from '../../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../../app-config.service';
import { inject } from '@angular/core';

export class CountryGateway implements IGetGateway<
  null,
  IApiResponse<ICountry[]>
> {
  private readonly configService: AppConfigService = inject(AppConfigService);
  private readonly restCallBuilder: RestCallBuilder<ICountry[]> =
    new RestCallBuilder<ICountry[]>([]);

  get(): Observable<IApiResponse<ICountry[]>> {
    return this.restCallBuilder
      .getExternal(
        `${this.configService.get().general.addressValidationUrl}/countries/`
      )
      .validate(API_RESPONSE_SCHEMA(COUNTRIES_SCHEMA), 'Countries.get')
      .handleMessages()
      .build();
  }
}
